import React, { useEffect, useRef } from 'react';
import mapboxgl, { GeolocateControl, NavigationControl } from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

mapboxgl.accessToken = 'pk.eyJ1IjoiOWE3dDYiLCJhIjoiY2xiZWF1MWdlMDluOTNvcGF6Zmx3bng2ayJ9.8bB7_aVExETntLYL9F0fOA';

const defaultLat = 45.508866443263
const defaultLng = -73.56169608362485

const MapboxMap = ({ onLocationSelect, initialLat, initialLng, initialZoom = 10 }) => {
    const mapContainerRef = useRef(null);
    const mapRef = useRef(null);
    const markerRef = useRef(null);

    useEffect(() => {
        let centerCoordinates;

        if (initialLat && initialLng) {
            centerCoordinates = [initialLng, initialLat];
        } else {
            centerCoordinates = [defaultLng, defaultLat];
        }

        if (!mapContainerRef.current) {
            console.error('Map container not available.');
            return;
        }

        console.log('Initializing map with center:', centerCoordinates);

        const map = new mapboxgl.Map({
            container: mapContainerRef.current,
            style: 'mapbox://styles/mapbox/navigation-day-v1',
            center: centerCoordinates,
            zoom: initialZoom,
        });

        const navControl = new NavigationControl();
        map.addControl(navControl, 'top-left');

        const geoControlRef = new GeolocateControl();
        map.addControl(geoControlRef, 'top-left');

        const marker = new mapboxgl.Marker({ draggable: true })
            .setLngLat(centerCoordinates)
            .addTo(map);

        marker.on('dragend', () => {
            const { lng, lat } = marker.getLngLat();
            onLocationSelect({ lat, lng });
        });

        map.on('click', (e) => {
            const { lng, lat } = e.lngLat;
            marker.setLngLat([lng, lat]);
            onLocationSelect({ lat, lng });
            map.flyTo({ center: [lng, lat], zoom: 14 });
        });

        mapRef.current = map;
        markerRef.current = marker;

        // Ensure map resize after initialization
        map.resize();

        return () => {
            map.remove();
        };
    }, [initialLat, initialLng, initialZoom]);

    // Update marker position when initialLat or initialLng change
    useEffect(() => {
        if (mapRef.current && markerRef.current) {
            let centerCoordinates;

            if (initialLat && initialLng) {
                centerCoordinates = [initialLng, initialLat];
            } else {
                centerCoordinates = [defaultLng, defaultLat];
            }

            console.log('Updating marker position to:', centerCoordinates);
            markerRef.current.setLngLat(centerCoordinates);
            mapRef.current.flyTo({ center: centerCoordinates, zoom: 14 });
        }
    }, [initialLat, initialLng]);

    return (
        <div
            ref={mapContainerRef}
            className="h-full w-full"
            style={{ minHeight: '200px', width: '100%' }}
        />
    );
};

export default MapboxMap;
